import { create } from "zustand";
import {
  addToCartApi,
  getCartApi,
  decreaseQtyApi,
  removeFromCartApi,
} from "../services/api";
import { getGuestUserId } from "../utils/guestUser";

export const useCartStore = create((set, get) => ({
  cart: [],
  isLoading: true,

  // Load cart from backend
  loadCart: async () => {
    const userId = getGuestUserId();
    set({ isLoading: true });
    if (userId) {
      const items = await getCartApi(userId);
      set({ cart: items, isLoading: false });
    }

    set({ isLoading: false });
  },

  // Add or update a product
  addToCart: async (productId, product) => {
    const userId = getGuestUserId();
    await addToCartApi(userId, productId, 1);

    const cart = get().cart;
    const exists = cart.find((item) => item.productId === productId);

    if (exists) {
      set({
        cart: cart.map((item) =>
          item.productId === productId
            ? { ...item, quantity: item.quantity + 1 }
            : item,
        ),
      });
    } else {
      set({
        cart: [
          ...cart,
          {
            productId,
            title: product.name,
            price: product.price,
            image: product.image,
            quantity: 1,
          },
        ],
      });
    }
  },

  // Update quantity (+1, -1)
  updateQty: async (productId, change) => {
    const userId = getGuestUserId();
    console.log("updateQty CALLED →", { productId, change });
    if (change === 1) {
      await addToCartApi(userId, productId, 1);
    } else {
      console.log("Calling API: decreaseQtyApi");
      await decreaseQtyApi(userId, productId);
    }

    const cart = get().cart;
    console.log("Before update cart =", cart);
    set({
      cart: cart
        .map((item) =>
          item.productId === productId
            ? { ...item, quantity: item.quantity + change }
            : item,
        )
        .filter((i) => i.quantity > 0),
    });
  },

  // Remove product completely from cart
  removeItem: async (productId) => {
    const userId = getGuestUserId();

    try {
      await removeFromCartApi(userId, productId);

      set({
        cart: get().cart.filter((item) => item.productId !== productId),
      });
    } catch (error) {
      console.error("Failed to remove item:", error);
    }
  },

  getQuantity: (productId) => {
    return get().cart.find((i) => i.productId === productId)?.quantity || 0;
  },
}));
